import React, { useContext } from 'react'
import { ContextProvider } from '../context/Context'
import { Navigate } from 'react-router-dom'

const Protected:React.FC<React.PropsWithChildren> = ({children}) => {
  
  const {state}:any = useContext(ContextProvider)

  if(!state.token) return <Navigate to='/' />
  
  return (
   <>
    {children}
   </> 
  )
}

export default Protected